import * as React from 'react'

export const ManWithError = (props: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width={153} height={156} viewBox='0 0 153 156' fill='none' {...props}>
      <path
        d='M70.801 72.843c-61.42-.946-54.754 7.333-55.07-30.336.494-17.701-2.03-28.76 3.827-32.327 4.024-3.588 19.31-1.281 36.628-1.893 12.229.395 19.369-2.089 23.215 5.401 1.815 5.263.611 3.982.947 8.082-.612 41.276 3.471 49.693-9.547 51.073z'
        fill='url(#prefix__paint0_linear)'
      />
      <path
        d='M143.186 72.843c-61.415-.946-54.749 7.333-55.064-30.336.493-17.701-2.052-28.76 3.826-32.328 4.023-3.587 19.308-1.28 36.624-1.892 12.227.394 19.367-2.09 23.213 5.401 1.814 5.263.611 3.982.946 8.082-.611 41.276 3.471 49.693-9.545 51.073z'
        fill='url(#prefix__paint1_linear)'
      />
      <path
        d='M70.801 145.227c-61.42-.946-54.754 7.333-55.07-30.336.494-17.702-2.031-28.76 3.827-32.328 4.024-3.587 19.31-1.28 36.627-1.892 12.23.394 19.37-2.09 23.216 5.401 1.814 5.263.611 3.982.946 8.082-.611 41.276 3.472 49.693-9.546 51.073z'
        fill='url(#prefix__paint2_linear)'
      />
      <path
        d='M143.186 145.227c-61.415-.946-54.749 7.333-55.064-30.336.493-17.702-2.052-28.76 3.826-32.328 4.023-3.587 19.308-1.28 36.624-1.892 12.227.394 19.367-2.09 23.213 5.401 1.814 5.263.611 3.982.946 8.082-.611 41.276 3.471 49.693-9.545 51.073z'
        fill='url(#prefix__paint3_linear)'
      />
      <path
        d='M78.624 6.093v136.585c0 2.045-1.763 2.556-3.765 2.693l-69.767 6.172-1.07.079C1.803 151.779 0 150.128 0 147.985V3.794A3.833 3.833 0 013.864 0h.158L5.49.04l70.004 5.306c2.002.06 3.131-1.297 3.131.747z'
        fill='url(#prefix__paint4_linear)'
      />
      <path
        d='M80.496 6.096V142.67c0 2.045-1.577 3.835-3.549 3.972L52.4 148.373l-45.94 3.244c-1.992.177-3.767-1.278-3.944-3.264-.02-.118-.02-.256-.02-.374V3.795C2.496 1.711 4.211 0 6.301 0h.178l27.268.865 43.2 1.396c1.992.06 3.55 1.79 3.55 3.835z'
        fill='url(#prefix__paint5_linear)'
      />
      <path
        d='M78.624 13.45v126.813c0 1.911-1.522 3.585-3.381 3.703l-66.514 4.531c-1.878.177-3.54-1.221-3.717-3.093 0-.098-.02-.216-.02-.315V11.677c.02-1.97 1.641-3.565 3.618-3.565h.119l66.514 1.753c1.859.079 3.381 1.674 3.381 3.585z'
        fill='url(#prefix__paint6_linear)'
      />
      <path
        opacity={0.3}
        d='M52.457 148.373L6.48 151.617c-1.992.177-3.767-1.278-3.964-3.264-.02-.118-.02-.236-.02-.374V3.795C2.496 1.711 4.212 0 6.303 0h.177L33.76.865c-4.024 18.348-9.566 58.11 11.42 80.725 21.44 23.087 23.176 48.573 7.278 66.783z'
        fill='#fff'
      />
      <path
        d='M62.4 44.498c0 11.826-9.594 22.043-21.459 22.847-11.904.784-21.597-8.217-21.597-20.121 0-11.904 9.693-22.14 21.597-22.847C52.806 23.652 62.4 32.673 62.4 44.498z'
        fill='url(#prefix__paint7_linear)'
      />
      <path
        d='M63.648 44.498c0 11.825-9.594 22.042-21.459 22.846-11.904.785-21.597-8.217-21.597-20.12 0-11.904 9.693-22.141 21.597-22.847 11.865-.726 21.459 8.295 21.459 20.12z'
        fill='url(#prefix__paint8_linear)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.84 36.96a1.56 1.56 0 012.207 0l7.009 7.01 7.009-7.01a1.56 1.56 0 012.206 2.207l-7.009 7.009 7.01 7.009a1.56 1.56 0 01-2.207 2.206l-7.009-7.009-7.009 7.01a1.56 1.56 0 01-2.206-2.207l7.009-7.009-7.01-7.009a1.56 1.56 0 010-2.206z'
        fill='#fff'
      />
      <path
        d='M74.256 61.152c-5.225 1.581-11.916 7.708-15.4 11.088-8.055 7.768-23.197 33.956-14.37 43.305 5.998 6.364 16.548 3.696 21.2-2.728 3.424-4.724 1.345-9.013.633-17.511-.812-9.132 2.474-25.121 7.937-34.154z'
        fill='url(#prefix__paint9_linear)'
      />
      <path
        d='M69.328 63.71c-3.575 4.268-4.832 3.912-7.62 9.8-4.203 8.854-1.1 18.991-.668 29.9.49 11.975 0 34.246-5.97 45.767a.892.892 0 00-.158.534c.177 12.212 57.506 3.656 57.408-.81-.452-22.133-14.789-70.608-11.234-86.654-1.61-.02-4.792-1.72-6.088-2.095a37.365 37.365 0 00-15.85-1.107c-1.925.257-2.887.712-4.301 1.245-2.278.91-3.751 2.214-5.52 3.42z'
        fill='url(#prefix__paint10_linear)'
      />
      <path
        d='M90.115 46.8c-.078 3.79 1.124 9.252 1.59 12.659.465 3.406-6.204 3.548-8.395 1.975-1.997-1.451-.485-5.382 1.435-7.438 1.919-2.056 3.392-5.1 5.37-7.196z'
        fill='url(#prefix__paint11_linear)'
      />
      <path
        d='M79.993 45.984c-3.096-2.793-3.66-12.73-.526-14.665 1.519-.938 4.167 3.95 5.9 4.888 2.316 1.277 8.605 2.674 9.85 5.228.935 1.915-.953 5.886-1.712 7.323-.857 1.616-.954 1.057-1.986 2.194-1.422 1.597-3.33 3.432-4.77 5.208-.312-1.357-.234-1.357-.779-3.093-.214-.678-1.927-3.511-2.745-4.589-.565-.698-2.862-2.155-3.232-2.494z'
        fill='url(#prefix__paint12_linear)'
      />
      <path
        d='M89.978 53.749c-2.416 2.233-3.604 4.96-8 4.13-3.92-.73-4.593-10.514-1.01-13.4 1.189-.968 2.931-.948 4.416-.513.871.257 1.782.85 2.673 1.166.812.316 1.485-.06 2.238.751.93 1.028.297 3.637-.238 4.882.396-.356.871-.85 1.386-1.028.377-.119 1.03-.731 1.386-.198.575.87-.673 2.55-1.405 3.242-.357.336-1.03.711-1.446.968z'
        fill='url(#prefix__paint13_linear)'
      />
      <path
        d='M90.786 44.978c-.531.321.413 1.325.276 2.328-.276 1.927-.886 5.418-3.64 5.76-1.634.2-3.346-1.285-5.078-1.466a9.051 9.051 0 00-3.286.241c-.689 2.087-.708 5.358 1.063 6.643 1.908 1.384 3.148.662 5.195.08 1.357-.401 2.853-1.585 3.7-2.95.885-1.405 1.534-2.89 2.42-4.375.491-.822 1.082-1.846 1.652-2.709.197-.28.374-.602.512-.923-.492-.462-2.027-3.07-2.814-2.629z'
        fill='url(#prefix__paint14_linear)'
      />
      <path
        d='M80.848 53.075c.794.45 1.724.45 2.595.45.039 0 .232-.078.155.078-.271.586-1.433.801-2.033.625-.426-.117-1.124-.645-1.066-1.094.04-.195.272-.02.35-.059z'
        fill='url(#prefix__paint15_linear)'
      />
      <path
        d='M74.375 134.31c-1.531-1.737-3.987-4.521-4.124-8.391-.373-9.971 14.966-13.861 14.357-21.956-.472-6.299-9.86-5.588-15.202-16.783-.923-1.916-4.281-9.221-1.846-17.494a22.133 22.133 0 013.752-7.286c-.668.474-1.297.948-1.984 1.422-3.575 4.264-4.832 3.91-7.62 9.793-4.203 8.846-1.1 18.975-.668 29.874.49 11.965 0 34.217-5.97 45.729a.89.89 0 00-.158.533c1.336 12.123 57.506 3.652 57.408-.81-.059-2.665-.314-5.726-.707-9.043-1.984.513-26.24 6.911-37.238-5.588z'
        fill='url(#prefix__paint16_linear)'
      />
      <path
        d='M58.343 96.049c-3.151-.16-.965-2.093-1.93-1.794-.59.18-15.182 14.685-10.594 22.337 4.391 7.312 22.585 2.351 29.005.039 3.564-1.295 14.157-5.28 20.596-15.641a42.737 42.737 0 001.3-2.291c-14.06-1.873-20.794-2.312-24.318-2.332-2.265-.02-4.53.18-14.06-.318z'
        fill='url(#prefix__paint17_linear)'
      />
      <path
        d='M63.648 94.484c.394 3.187 2.031 13.003 10.293 21.058 1.637 1.603 12.797 12.093 28.434 9.46 12.226-2.078 23.091-11.459 25.615-23.195 4.91-22.899-24.254-43.106-30.939-39.642-4.496 2.335-5.777 18.9.947 27.272 1.46 1.821 4.18 4.354 3.766 7.521-.394 3.048-3.47 4.968-5.225 6.017-8.223 4.967-26.187-7.897-30.939-8.946-.355-.02-.611-.337-1.952.455z'
        fill='url(#prefix__paint18_linear)'
      />
      <path
        d='M107.325 89.252c-2.845-2.872-6.124-4.398-9.818-5.547-.928-.257-1.857-.475-2.766-.713.751 2.357 1.838 4.556 3.3 6.379 1.461 1.822 4.187 4.358 3.772 7.528-.395 3.05-3.476 4.972-5.234 6.022-8.218 4.972-26.215-7.904-30.975-8.954-.336 0-.593-.337-1.956.455.138 1.189.355 2.358.612 3.527 6.756-2.18 14.085 4.635 19.932 7.943 7.507 4.259 16.851 7.013 24.18 1.387 5.492-4.14 3.496-13.292-1.047-18.027z'
        fill='url(#prefix__paint19_linear)'
      />
      <path
        d='M95.472 100.639c.399.882 2.353 1.8 3.29 1.688 1.595-.169 2.711-1.181 3.688-1.631.897-.394 2.871-.938 2.991-1.594.219-1.256-1.934-1.612-3.21-1.725-1.775-.168-3.688.32-5.443 1.107-.439.73-.937 1.443-1.316 2.155z'
        fill='url(#prefix__paint20_linear)'
      />
      <path
        d='M61.152 96.199c5.93.916 7.299.458 7.47-.104.209-.729-1.388-2.207-3.098-2.457-1.711-.25-3.479.75-4.372 2.56z'
        fill='url(#prefix__paint21_linear)'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear'
          x1={15.595}
          y1={40.569}
          x2={80.487}
          y2={40.569}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear'
          x1={87.983}
          y1={40.569}
          x2={152.869}
          y2={40.569}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint2_linear'
          x1={15.595}
          y1={112.952}
          x2={80.487}
          y2={112.952}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint3_linear'
          x1={87.983}
          y1={112.952}
          x2={152.869}
          y2={112.952}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint4_linear'
          x1={93.638}
          y1={123.451}
          x2={27.683}
          y2={66.734}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D4E5EE' />
          <stop offset={1} stopColor='#BCD6E1' />
        </linearGradient>
        <linearGradient
          id='prefix__paint5_linear'
          x1={4.432}
          y1={75.57}
          x2={138.818}
          y2={80.582}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D4E5EE' />
          <stop offset={1} stopColor='#BCD6E1' />
        </linearGradient>
        <linearGradient
          id='prefix__paint6_linear'
          x1={4.992}
          y1={78.326}
          x2={78.624}
          y2={78.326}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#fff' />
          <stop offset={1} stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint7_linear'
          x1={19.334}
          y1={45.861}
          x2={62.396}
          y2={45.861}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6A2E65' />
          <stop offset={1} stopColor='#F04181' />
        </linearGradient>
        <linearGradient
          id='prefix__paint8_linear'
          x1={20.578}
          y1={45.861}
          x2={63.642}
          y2={45.861}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CC0A51' />
          <stop offset={0.62} stopColor='#FF4086' />
        </linearGradient>
        <linearGradient
          id='prefix__paint9_linear'
          x1={96.884}
          y1={128.146}
          x2={50.677}
          y2={79.061}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3A3CA6' />
          <stop offset={0.51} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint10_linear'
          x1={93.893}
          y1={169.048}
          x2={67.442}
          y2={65.846}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset={1} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint11_linear'
          x1={84.287}
          y1={45.723}
          x2={95.314}
          y2={85.2}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset={1} stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='prefix__paint12_linear'
          x1={88.312}
          y1={49.753}
          x2={81.716}
          y2={20.501}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26264F' />
          <stop offset={1} stopColor='#444B8C' />
        </linearGradient>
        <linearGradient
          id='prefix__paint13_linear'
          x1={88.378}
          y1={52.375}
          x2={55.871}
          y2={42.344}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset={1} stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='prefix__paint14_linear'
          x1={85.823}
          y1={50.256}
          x2={79.219}
          y2={20.82}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26264F' />
          <stop offset={1} stopColor='#444B8C' />
        </linearGradient>
        <linearGradient
          id='prefix__paint15_linear'
          x1={80.344}
          y1={46.965}
          x2={90.763}
          y2={85.396}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset={1} stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='prefix__paint16_linear'
          x1={92.65}
          y1={178.061}
          x2={63.823}
          y2={76.73}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset={0.9} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint17_linear'
          x1={73.102}
          y1={143.12}
          x2={71.241}
          y2={113.416}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.03} stopColor='#3A3CA6' />
          <stop offset={0.19} stopColor='#3B41AB' />
          <stop offset={0.41} stopColor='#3F51B8' />
          <stop offset={0.64} stopColor='#466ACE' />
          <stop offset={0.89} stopColor='#4F8DEC' />
          <stop offset={1} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint18_linear'
          x1={88.557}
          y1={171.468}
          x2={100.143}
          y2={55.86}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3A3CA6' />
          <stop offset={0.51} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint19_linear'
          x1={85.366}
          y1={129.304}
          x2={88.996}
          y2={79.917}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#475CA3' />
          <stop offset={0.9} stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient
          id='prefix__paint20_linear'
          x1={101.745}
          y1={87.94}
          x2={100.015}
          y2={106.204}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset={1} stopColor='#311944' />
        </linearGradient>
        <linearGradient
          id='prefix__paint21_linear'
          x1={66.076}
          y1={83.334}
          x2={63.848}
          y2={103.553}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#893976' />
          <stop offset={1} stopColor='#311944' />
        </linearGradient>
      </defs>
    </svg>
  )
}
